import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree, Router } from "@angular/router";
import { Observable } from "rxjs";
import { AuthenticationRepository } from "src/app/core/data/repository";
import { RoutesConstants } from "../common";

@Injectable({
  providedIn: 'root',
})
export class ThemeExistGuard implements CanActivate {
    constructor(private authenticationRepository: AuthenticationRepository, private router: Router) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        const currentUser = this.authenticationRepository.currentUser$.value;
        const loggedUserAppType = this.authenticationRepository.getApplicationTypeFromToken();
        const availableUserAppTypes = currentUser.appsType;
        const isSuperAdmin = !loggedUserAppType && !availableUserAppTypes.length
        
        if (!loggedUserAppType && !isSuperAdmin) {
            this.router.navigate(['/' + RoutesConstants.THEME_ERROR_PAGE_URL]);
            return false;
        }
        return true
    } 
}